<template>
  <div v-bind="$attrs" :class="`elliptic-mark ${getClassName}`">
    <div :class="`inner-ring ${getClassName}`">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getClassName () {
      return this.type
    }
  },
  props: {
    type: {
      type: String,
      default: 'info'
    },
    text: {
      type: String,
      default: '空'
    }
  },
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.elliptic-mark{
  width: 140px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  // transform: translateY(-50%) rotate(34deg);
  transform: translateY(-50%);
  right: 3%;
}
.inner-ring{
  width: 90%;
  height: 90%;
  border-radius: 50%;
  position: absolute;
  margin: auto;
  inset: 0 1px 0 0;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.info{
  border: 1px solid rgb(255, 148, 61);
  color: rgb(255, 148, 61);
}
.primary{
  border: 1px solid #297CF0;
  color: #297CF0;
}
.error {
  border: 1px solid rgb(244, 104, 93);
  color: rgb(244, 104, 93);
}
.success {
  border: 1px solid #0C9F69;
  color: #0C9F69;
}
</style>
